import React from 'react';
import dynamic from 'next/dynamic';
import { TOUR_TYPES, SLUGS_TYPES } from 'lib/utils/CONSTANTS';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { HydrationWrapper } from 'views/common/components';
import { ErrorPageV2 } from 'views/rebranded-module/common/components';
import { handleServerResponse } from 'views/tours-module/utils';
import { prepareTranslationFiles } from 'views/tours-module/utils/prepareTranslationFiles';
import { checkIfUrlHasCorrectSegmentsTranslations } from 'lib/utils/checkIfUrlHasCorrectSegmentsTranslations';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useToursListingCMSData } from 'views/rebranded-module/tours-module/ToursListingViewV2/hooks/useToursListingCMSData';

const ToursListingViewV2 = dynamic(() => import('views/rebranded-module/tours-module/ToursListingViewV2').then(
  (file) => file.ToursListingViewV2,
));

const TourViewV2 = dynamic(() => import('views/rebranded-module/tours-module/TourViewV2').then(
  (file) => file.TourViewV2,
));

const SelfToursListingPage = (props) => {
  const {
    detectSlugsSSRData,
    serverData,
    ssrRender,
    deviceType,
    bookingDetailsData,
    serverError,
    cmsData,
  } = props;

  const appNavigator = useAppNavigator();
  const toursListingContent = useToursListingCMSData();
  const slug = detectSlugsSSRData?.slugSSR;

  // eslint-disable-next-line consistent-return
  const renderPage = () => {
    if (serverError) {
      return <ErrorPageV2 statusCode={serverError.statusCode} />;
    }
    if (
      !appNavigator.query.slug
      || (slug?.slugs[0].slug_type
        && slug?.slugs[0].slug_type !== SLUGS_TYPES.self_drive)
    ) {
      return (
        <ContentContext.Provider value={toursListingContent.data}>
          <ToursListingViewV2
            slugData={slug}
            serverData={serverData}
            tourType={TOUR_TYPES.SELF_DRIVE}
          />
        </ContentContext.Provider>
      );
    }
    if (
      slug?.slugs[0].slug_type
      && slug?.slugs[0].slug_type === SLUGS_TYPES.self_drive
    ) {
      return (
        <TourViewV2
          serverData={serverData}
          deviceType={deviceType}
          ssrRender={ssrRender}
          slugData={slug}
          bookingDetailsDataInit={bookingDetailsData}
          cmsData={cmsData}
        />
      );
    }
  };

  return <HydrationWrapper>{renderPage()}</HydrationWrapper>;
};
export async function getServerSideProps(ctx) {
  const options = {
    transparentNavBar: true,
    staticNavBar: true,
  };
  const serverResponse = await handleServerResponse(ctx, TOUR_TYPES.SELF_DRIVE);

  if (serverResponse?.detectSlugsSSRData?.newPath) {
    return {
      redirect: {
        destination: serverResponse.detectSlugsSSRData?.newPath,
        permanent: true,
      },
    };
  }
  if (serverResponse?.redirectURL) {
    return {
      redirect: {
        destination: serverResponse.redirectURL,
        permanent: true,
      },
    };
  }

  const translation = await prepareTranslationFiles(ctx, TOUR_TYPES.GUIDED);

  const isCorrectSegemntTranslation = checkIfUrlHasCorrectSegmentsTranslations(
    ctx,
    serverResponse?.hreflangData?.canonical,
  );
  if (isCorrectSegemntTranslation.shouldRedirect) {
    return {
      redirect: {
        destination: isCorrectSegemntTranslation.redirectURL,
        permanent: true,
      },
    };
  }

  return {
    props: {
      ...serverResponse,
      ...translation,
      options,
      rebrandingPage: true,
    },
  };
}

export default SelfToursListingPage;
